/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import orderImg from "../../icons/order.png"
import { useEffect, useState } from "react";
import moment from "moment";
import searchicon_black from "../../icons/searchicon_black.png";
import { Link } from "react-router-dom";
import style from "../../components/Search&Options/Search&Options.module.css";
import "./switch.css";
import { Paginated } from "../../components/Paginated";
import CircularProgress from '@mui/material/CircularProgress';
import ThemeMaker from "../../components/thememaker";
import * as XLSX from 'xlsx';
import { Tag } from "antd";
import { toast } from "react-toastify";

const completeOrder = () => {
  const decoded: any = tokenDecode();
  const [orderList, setOrderList] = useState([]);
  const [sellerList, setSellerList] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const { apiEndpoint } = config;
  const [toggle, setToggle] = useState(false);
  const rawData = {
    provider_id: "",
  };
  const [searchData, setSearchData]: any = useState(rawData);
  const [sorderList, setSorderList] = useState([]);

  const [valuename, setValuename] = useState("");
  const [valueid, setValueid] = useState("");
  const [valueemail, setValueemail] = useState("");
  const [valuecontact, setValuecontact] = useState("");
  const [valuestatus, setValuestatus] = useState("");
  const [valueamount, setValueamount] = useState("");
  const [valuedate, setValuedate] = useState("");
  const [allorders, setallorders] = useState([])
  const { data } = decoded;
  const {
    permission: { category, order, product, role, seller, tax, user },
  } = data;

  // ---- COMBINED FILTER STATE (Order ID + Payment Status + Date) ----
  const [filters, setFilters] = useState({
    order_id: "",
    payment_type: "",
    created_at: "",
  });

  // Single function that always sends ALL currently active filters together
  const applyFilters = async (updatedFilters: typeof filters) => {
    const hasAnyFilter = Object.values(updatedFilters).some((v) => v && v.trim() !== "");

    // No filters active at all → show full unfiltered completed order list
    if (!hasAnyFilter) {
      getSellerList();
      return;
    }

    const payload: any = {};
    if (updatedFilters.order_id.trim()) payload.order_id = updatedFilters.order_id.trim();
    if (updatedFilters.payment_type.trim()) payload.payment_type = updatedFilters.payment_type.trim();
    if (updatedFilters.created_at.trim()) payload.created_at = updatedFilters.created_at.trim();

    try {
      setIsLoading(true);
      setToggle(true);
      const { data } = await axios({
        url: `${apiEndpoint}/snp/orders/filter-completed-order-list`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: payload,
      });

      if (data && (data.status === true || data.status === 200) && Array.isArray(data.orders) && data.orders.length > 0) {
        setOrderList(data.orders);
        setSellerList(data.orders);
      } else {
        setOrderList([]);
        setSellerList([]);
      }
    } catch (error) {
      console.log("error", error);
      setOrderList([]);
      setSellerList([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Individual field handlers — each updates its own value AND merges into the shared filter state
  const handleOrderIdChange = (e: any) => {
    const value = e.target.value;
    setValueid(value);
    const updated = { ...filters, order_id: value };
    setFilters(updated);
    applyFilters(updated);
  };

  const handlePaymentStatusChange = (e: any) => {
    const value = e.target.value;
    setValuestatus(value);
    const updated = { ...filters, payment_type: value };
    setFilters(updated);
    applyFilters(updated);
  };

  const handleDateChange = (e: any) => {
    const value = e.target.value;
    setValuedate(value);
    const updated = { ...filters, created_at: value };
    setFilters(updated);
    applyFilters(updated);
  };

  const handleClearDate = () => {
    setValuedate("");
    const updated = { ...filters, created_at: "" };
    setFilters(updated);
    applyFilters(updated);
  };

  const fetchSellerList = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getsellerordercompletelist`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          seller_id: decoded?.data?.user?.seller_id,
        },
      });
      // console.log("order data -> ", data.data);
      setOrderList(data.data);
      // const order = data.data;
      // console.log("line 34", orderList);
      if (data.status === 200) {
        setOrderList(data.data);
        setIsLoading(false);

      }
    } catch (error) {
      console.log("error", error);

      setIsLoading(false);
    }
  };

  const getSellerList = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/orders/get-completed-order-list`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      if (data && data.status === true && data.orders) {
        setOrderList(data.orders);
        setSellerList(data.orders);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };

  const COLUMNS = [
    {
      Header: "Serial No.",
      accessor: (row: any, count: any) => {
        return <>{count + 1}</>
      },
      disableFilters: true,
      sticky: "left"
    },
    {
      Header: "Order ID",
      accessor: (a: any) => (
        <span className="font-weight-bold" style={{ color: "#0F172A" }}>
          {a?.order_id || "-"}
        </span>
      ),
      sticky: "left"
    },
    {
      Header: "BAP ID",
      accessor: (a: any) => (
        <span style={{ color: "#475569", fontWeight: 500, fontSize: "13px" }}>
          {a?.bap_id || "-"}
        </span>
      ),
      sticky: "left"
    },
    {
      Header: "Order Status",
      accessor: (a: any) => {
        const state = (a?.order_state || a?.status || "Completed").toUpperCase();
        return (
          <span
            className="badge"
            style={{
              backgroundColor: "#DCFCE7",
              color: "#15803D",
              border: "1px solid #BBF7D0",
              borderRadius: "20px",
              padding: "5px 12px",
              fontWeight: 600,
              fontSize: "12px",
            }}
          >
            {state}
          </span>
        );
      },
      sticky: "left",
    },
    {
      Header: "Item",
      accessor: (a: any) => a?.item_count ?? "-",
      sticky: "left",
    },
    {
      Header: "Customer Name",
      accessor: (a: any) => (
        <span style={{ color: "#334155" }}>
          {a?.name || "-"}
        </span>
      ),
      sticky: "left"
    },
    {
      Header: "Total (In Rs)",
      accessor: (a: any) => (
        <span className="font-weight-bold" style={{ color: "#F97316" }}>
          ₹{a?.order_total ?? 0}
        </span>
      ),
      sticky: "left"
    },
    {
      Header: "Payment Status",
      accessor: (row: any) => {
        const paymentType = (row?.payment_type || "").toUpperCase();
        const paymentStatusStr = (row?.payment_status || row?.status || "").toUpperCase();
        const isPaid = paymentType === "ON-ORDER" || paymentStatusStr === "ON-ORDER" || paymentStatusStr === "PAID";
        return (
          <span
            className="badge"
            style={{
              backgroundColor: isPaid ? "#DCFCE7" : "#FEF3C7",
              color: isPaid ? "#15803D" : "#B45309",
              border: `1px solid ${isPaid ? "#BBF7D0" : "#FDE68A"}`,
              borderRadius: "20px",
              padding: "5px 12px",
              fontWeight: 600,
              fontSize: "12px",
            }}
          >
            {isPaid ? "PAID" : "COD / UNPAID"}
          </span>
        );
      },
      sticky: "left"
    },
    {
      Header: "Created Date",
      accessor: (a: any) => a?.created_at ? moment(a.created_at).format("DD MMM YYYY, hh:mm A") : "-",
      sticky: "left"
    },
    {
      Header: "Action",
      accessor: (item: any) => {
        return (
          <Link to={`/orderCompleteDetail/${item.order_id}`}>
            <span
              className="btn btn-sm text-white font-weight-bold"
              style={{
                backgroundColor: "#F97316",
                borderColor: "#F97316",
                borderRadius: "8px",
                padding: "5px 14px",
                fontSize: "12px"
              }}
            >
              Get Order Details
            </span>
          </Link>
        );
      },
      sticky: "left"
    },
  ];

  const inputHandler = async (e: any) => {
    setValuename("");
    setValueid("");
    setValueemail("");
    setValuecontact("");
    setValuestatus("");
    setValueamount("");
    setValuedate("");
    var optionvalue = e.target.value;
    if (optionvalue) {
      try {
        setSearchData({ ...searchData, [e.target.name]: e.target.value });
        const { data } = await axios({
          url: `${apiEndpoint}/filterbyseller`,
          method: "POST",
          headers: {
            "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: {
            provider_id: optionvalue,
          },
        });

        if (data.status === 200) {
          console.log(data);
          setOrderList(data.data);
          setSorderList(data.data);
          setToggle(true);
        }
      } catch (error) {
        console.log("error", error);
      }
    } else {
      setOrderList(sorderList);
    }
  };
  const inputeHandler = async (e: any) => {
    const optionvalue = e.target.value;
    setValuename(optionvalue);
    if (optionvalue) {
      try {
        const { provider_id } = searchData;
        setToggle(true);
        setSearchData({ ...searchData, [e.target.name]: e.target.value });
        const { data } = await axios({
          url: `${apiEndpoint}/filterbysellerorder`,
          method: "POST",
          headers: {
            "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: {
            provider_id: { searchData },
            name: optionvalue,
            order_status: "Completed"
          },
        });

        console.log({
          data: {
            provider_id: { searchData },
            name: optionvalue,
          },
        });

        if (data.status === 200) {
          console.log(data);
          setOrderList(data.response);
        }
      } catch (error) {
        console.log("error", error);
      }
    } else {
      inputHandler(e);
    }
  };
  const inputeeHandler = async (e: any) => {
    const optionvalue = e.target.value;
    setValuename(optionvalue);
    if (optionvalue) {
      try {
        setToggle(true);
        setSearchData({ ...searchData, [e.target.name]: e.target.value });
        const { data } = await axios({
          url: `${apiEndpoint}/filterordersellerloginb`,
          method: "POST",
          headers: {
            "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: {
            name: optionvalue,
            order_status: "Completed"
          },
        });

        if (data.status === 200) {
          console.log(data.response);
          setOrderList(data.response);
        }
      } catch (error) {
        console.log("error", error);
      }
    } else {
      fetchSellerList();
    }
  };

  const [isExporting, setIsExporting] = useState(false);

  const exportToExcel = (orders: any) => {
    const orderList = Array.isArray(orders) ? orders : [];
    if (orderList.length === 0) {
      toast.info("No orders available to export.");
      return;
    }

    // Custom column headers for the Excel file
    const headers = [
      "S.No",
      "Order Id",
      "BAP ID",
      "Created At",
      "Seller Name",
      "Order State",
      "Customer Name",
      "Customer Email",
      "Customer Contact",
      "Payment Status",
      "Item Count",
      "Order Total"
    ];

    // Prepare data
    const data = orderList.map((order: any, index: any) => {
      let orderCreatedDate = order?.created_at
        ? moment(order.created_at).format("DD-MM-YYYY hh:mm:ss A")
        : "-";
      let sellerName = order?.name || order?.seller_name || order?.address?.start?.location?.descriptor?.name || "-";
      let sellerEmail = order?.address?.end?.contact?.email || order?.email || "-";
      let sellerContact = order?.address?.end?.contact?.phone || order?.contact_number || "-";
      let customerName = order?.name || "-";
      let orderState = order?.order_state || "-";
      let rawPaymentType = (order?.payment_type || "").toUpperCase();
      let rawPaymentStatus = (order?.payment_status || order?.status || "").toUpperCase();
      let isPaidOrder = rawPaymentType === "ON-ORDER" || rawPaymentStatus === "ON-ORDER" || rawPaymentStatus === "PAID";
      let paymentStatus = isPaidOrder ? "PAID" : "COD / UNPAID";
      let itemCount = order?.item_count !== undefined ? order.item_count : (order?.items ? (Array.isArray(order.items) ? order.items.length : 1) : 1);
      let orderTotal = order?.order_total !== undefined ? order.order_total : 0;

      return {
        "S.No": index + 1,
        "Order Id": order?.order_id || "-",
        "BAP ID": order?.bap_id || "-",
        "Created At": orderCreatedDate,
        "Seller Name": sellerName,
        "Order State": orderState,
        "Customer Name": customerName,
        "Customer Email": sellerEmail,
        "Customer Contact": sellerContact,
        "Payment Status": paymentStatus,
        "Item Count": itemCount,
        "Order Total": orderTotal,
      };
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data, { header: headers });

    ws["!cols"] = [
      { wch: 8 },  // S.No
      { wch: 16 }, // Order Id
      { wch: 24 }, // Created At
      { wch: 26 }, // Seller Name
      { wch: 16 }, // Order State
      { wch: 20 }, // Customer Name
      { wch: 24 }, // Customer Email
      { wch: 18 }, // Customer Contact
      { wch: 16 }, // Payment Status
      { wch: 12 }, // Item Count
      { wch: 14 }, // Order Total
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Completed_Orders");
    const fileName = `completed_orders_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;
    XLSX.writeFile(wb, fileName);
    toast.success("Excel downloaded successfully!");
  };

  const handleExportExcel = async () => {
    try {
      setIsExporting(true);
      const token = sessionStorage.getItem("token");
      const res = await fetch(`${apiEndpoint}/snp/orders/export-orders?mode=summary`, {
        method: "POST",
        headers: {
          ...(token ? { "Authorization": `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          orderType: "complete",
          order_id: valueid ? valueid.trim() : "",
          created_at: valuedate ? valuedate : "",
          payment_type: valuestatus ? valuestatus : "",
        }),
      });

      const contentType = res.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const data = await res.json();
        if (data?.status === false || data?.success === false || !res.ok) {
          toast.error(data?.message || "No orders found!");
          return;
        }

        if (data?.fileUrl || data?.url || data?.downloadUrl || data?.download_url) {
          const downloadLink = data.fileUrl || data.url || data.downloadUrl || data.download_url;
          window.open(downloadLink, "_blank");
          toast.success("Excel downloaded successfully!");
        } else if (data?.orders && Array.isArray(data.orders)) {
          if (data.orders.length === 0) {
            toast.error(data?.message || "No orders found!");
          } else {
            exportToExcel(data.orders);
          }
        } else if (data?.data && Array.isArray(data.data)) {
          if (data.data.length === 0) {
            toast.error(data?.message || "No orders found!");
          } else {
            exportToExcel(data.data);
          }
        } else if (Array.isArray(data)) {
          if (data.length === 0) {
            toast.error("No orders found!");
          } else {
            exportToExcel(data);
          }
        } else if (data?.message) {
          if (data?.status === true) {
            toast.success(data.message);
          } else {
            toast.error(data.message);
          }
        } else {
          toast.success("Excel downloaded successfully!");
        }
      } else {
        if (!res.ok) {
          throw new Error(`Export request failed with status: ${res.status}`);
        }
        const blob = await res.blob();
        const contentDisposition = res.headers.get("Content-Disposition") || res.headers.get("content-disposition");
        let filename = `completed_orders_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) filename = match[1];
        }
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        toast.success("Excel downloaded successfully!");
      }
    } catch (error: any) {
      console.error("Export excel error:", error);
      toast.error(error?.message || "Failed to export Excel. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  const exportorders = async () => {
    let payload;
    let sellerId = decoded?.data?.user?.seller_id;
    if (sellerId == 1 || sellerId > 1) {
      payload = sellerId
    }

    if (sellerId == 0) {
      payload = decoded?.data?.user?.parent_id;
    }
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getallstatusorderhhhhhh`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
        },
        data: {
          seller_id: payload,
        }
      });
      // console.log("order data -> ", data);
      if (data.status === 200) {

        setallorders(data.data)
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    // fetchSellerList();
    getSellerList();
    // exportorders();
  }, []);

  return (
    <>
      <ThemeMaker>
        <div className="row w-100 m-0 mt-2">
          <div className="col-md-12">
            <div className="card shadow-sm border p-4 mb-4" style={{ borderRadius: "20px", borderColor: "#E5E7EB", backgroundColor: "#ffffff", boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)", position: "sticky", top: "10px", zIndex: 30 }}>
              <div className="d-flex justify-content-between align-items-center flex-wrap mb-3" style={{ gap: "15px" }}>
                <h4 className="font-weight-bold m-0" style={{ color: "#0F172A", fontSize: "24px" }}>
                  Completed Orders
                </h4>

                <div className="d-flex align-items-end flex-wrap" style={{ gap: "12px" }}>
                  {/* Search Order ID Fieldset */}
                  <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                    <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                      Search Order ID
                    </legend>
                    <div className="d-flex align-items-center" style={{ marginTop: "-6px" }}>
                      <i className="fas fa-search mr-2" style={{ fontSize: "13px", color: "#F97316" }}></i>
                      <input
                        type="search"
                        name="order_id"
                        placeholder="Search Order ID..."
                        className="border-0 bg-transparent text-dark"
                        onChange={handleOrderIdChange}
                        value={valueid ? valueid : ""}
                        style={{ outline: "none", fontSize: "14px", width: "170px" }}
                      />
                    </div>
                  </fieldset>

                  {/* Payment Status Filter Fieldset */}
                  <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                    <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                      Payment Status
                    </legend>
                    <div className="d-flex align-items-center" style={{ marginTop: "-6px" }}>
                      <select
                        name="payment_status"
                        onChange={handlePaymentStatusChange}
                        value={valuestatus || ""}
                        style={{
                          border: "none",
                          outline: "none",
                          width: "130px",
                          height: "26px",
                          background: "transparent",
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#334155",
                          cursor: "pointer"
                        }}
                      >
                        <option value="">All Status</option>
                        <option value="ON-ORDER">Prepaid</option>
                        <option value="ON-FULFILLMENT">COD</option>
                      </select>
                    </div>
                  </fieldset>

                  {/* Filter By Date Fieldset */}
                  <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                    <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                      Filter By Date
                    </legend>
                    <div className="d-flex align-items-center" style={{ marginTop: "-6px" }}>
                      <input
                        type="date"
                        name="date"
                        value={valuedate || ""}
                        onChange={handleDateChange}
                        style={{
                          border: "none",
                          outline: "none",
                          width: "135px",
                          height: "26px",
                          background: "transparent",
                          fontSize: "13px",
                          color: "#334155",
                          cursor: "pointer"
                        }}
                      />
                      {valuedate && (
                        <button
                          type="button"
                          onClick={handleClearDate}
                          title="Clear Date"
                          style={{
                            border: "none",
                            background: "#FEE2E2",
                            color: "#EF4444",
                            borderRadius: "50%",
                            width: "18px",
                            height: "18px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "11px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            marginLeft: "4px",
                            padding: 0
                          }}
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  </fieldset>

                  {/* Export Excel Button */}
                  <button
                    className="btn text-white font-weight-bold d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: "#F97316",
                      borderColor: "#F97316",
                      borderRadius: "10px",
                      height: "40px",
                      padding: "0 18px",
                      fontSize: "13px",
                      boxShadow: "0 2px 6px rgba(249, 115, 22, 0.3)",
                      gap: "6px",
                      opacity: isExporting ? 0.7 : 1,
                      cursor: isExporting ? "not-allowed" : "pointer",
                      alignSelf: "flex-end"
                    }}
                    onClick={handleExportExcel}
                    disabled={isExporting}
                  >
                    {isExporting ? (
                      <>
                        <i className="fas fa-spinner fa-spin"></i> Exporting...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-file-excel"></i> Export Excel
                      </>
                    )}
                  </button>
                </div>
              </div>

              {!isLoading ? (
                <div>
                  {orderList && (
                    <>
                      <div className="table-border overflow-hidden" style={{ borderRadius: "16px", border: "1px solid #E5E7EB" }}>
                        <Paginated data={orderList} columns={COLUMNS as any} />
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
                  <CircularProgress style={{ color: "#F97316" }} />
                </div>
              )}
            </div>
          </div>
        </div>
      </ThemeMaker>
    </>
  );
};

export default completeOrder;